<template>
  <div class="UserEdit bc-white" v-title :data-title="userType==='hzdw'?'合作单位':'报价商'">
    <van-cell class="fc-primary fs7" title="账号信息" />
    <van-field
      label-width="70px"
      :class="userinfo.id?'disabled':''"
      :disabled="userinfo.id?true:false"
      v-model="userinfo.username"
      required
      clearable
      label="用户名"
      placeholder="请输入用户名"
    />
    <van-field
      label-width="70px"
      v-if="!userinfo.id"
      v-model="userinfo.password"
      clearable
      required
      type="text"
      label="密码"
      placeholder="请输入密码"
    />
    <van-field
      label-width="70px"
      v-else-if="changeFlag"
      v-model="userinfo.newPassword"
      clearable
      required
      type="text"
      label="密码"
      placeholder="请输入密码"
    />
    <div v-if="loginLink&&userType==='hzdw'" id="loginLink"
      @click="copyContentH5(loginLink, userinfo.cooperationInfo.companyName+'\n登录链接：')"
      class="text-left fs3 pt7 row align-items-baseline">
      <span class="fc-less">登录链接</span>
      <div class="pl2 flex-1">{{loginLink}}</div>
      <!-- <a class="padding2" v-if="loginLink">复制</a> -->
    </div>
    <div v-if="userinfo.id" class="save pt7">
      <!-- <van-button @click="saveStore" class="btn" type="info">保存</van-button> -->
      <template v-if="!changeFlag">
        <van-button
          class="btn-reset" @click="removeUser"
          type="warning" size="small" plain round>删除{{userType === 'bjs'?'账户':'用户'}}</van-button>
        <van-button v-if="userType === 'bjs'"
          class="btn-reset" @click="removeAll"
          type="danger" size="small" plain round>删除全部</van-button>
      </template>
      <van-button class="btn-reset"
        @click="changePWD" type="info"
        size="small" plain round>{{changeFlag?'保存新密码':'修改密码'}}</van-button>
    </div>
    <!-- <div v-if="!userinfo.id" class="save pt10">
      <van-button @click="saveUser" class="btn" type="info">保存用户信息</van-button>
    </div> -->
    <van-cell class="fc-primary fs7 mt7" :title="userType==='hzdw'?'合作单位':'报价商'" />
    <template v-if="userType==='bjs'">
      <van-field
        label-width="70px"
        v-model="storeinfo.name"
        clearable
        label="名称"
        placeholder="请输入名称"
      />
      <div class="row bc-white contact align-items-center">
        <div class="required-box text-left">
          <span class="required"></span>
          省/直辖市
        </div>
        <div class="flex-1 text-left">
          <div class="row align-items-center pt1 pb1">
            <select class="ad-select fs5" v-model="storeinfo.provinceCode" @change="changeRegion('province')">
              <option value="">请选择</option>
              <option v-for="ps in (options.provinceOptions||[])" :value ="ps.code" :key="ps.code">
                {{ps.name}}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="row bc-white contact align-items-center">
        <div class="required-box text-left">
          <span class="required"></span>
          市
        </div>
        <div class="flex-1 text-left">
          <div class="row align-items-center pt1 pb1">
            <select class="ad-select fs5" v-model="storeinfo.cityCode" @change="changeRegion('city')">
              <option value="">请选择</option>
              <option v-for="ps in options.cityOptions||[]" :value ="ps.code" :key="ps.code">
                {{ps.name}}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="row bc-white contact align-items-center">
        <div class="required-box text-left">
          <span class="required"></span>
          区/县
        </div>
        <div class="flex-1 text-left">
          <div class="row align-items-center pt1 pb1">
            <select class="ad-select fs5" v-model="storeinfo.areaCode" @change="changeRegion('area')">
              <option value="">请选择</option>
              <option v-for="ps in options.areaOptions||[]" :value ="ps.code" :key="ps.code">
                {{ps.name}}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="row bc-white contact align-items-center">
        <div class="required-box text-left">
          <span class="required"></span>
          乡镇
        </div>
        <div class="flex-1 text-left">
          <div class="row align-items-center pt1 pb1">
            <select class="ad-select fs5" v-model="storeinfo.townCode" @change="changeRegion('town')">
              <option value="">请选择</option>
              <option v-for="ps in options.townOptions||[]" :value ="ps.code" :key="ps.code">
                {{ps.name}}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="row bc-white contact align-items-center pt2 pb2">
        <div class="required-box text-left">
          <span class="required"></span>
          地址
        </div>
        <div class="flex-1 text-left">
          <!-- {{storeinfo.address}} -->
          <!-- <div class="fs1 fc-less">(原地址字段，仅在此展示)</div> -->
          <van-field
            label-width="70px"
            v-model="storeinfo.address"
            clearable
            placeholder="地址"
          />
        </div>
      </div>
      <div class="row bc-white contact align-items-center">
        <div class="required-box text-left">
          <span class="required"></span>
          联系方式
        </div>
        <div class="flex-1 text-left">
          <div class="row align-items-center pt1 pb1"
            v-for="(mo, index) in mobileList"
            :key="index">
            <div class="col-8">
              <van-field
                label-width="70px"
                v-model="mo.name"
                clearable
                placeholder="称呼"
              />
            </div>
            <div class="flex-1 pl2">
              <van-field
                label-width="70px"
                v-model="mo.mobile"
                clearable
                placeholder="电话号码"
              />
            </div>
            <van-icon v-if="index + 1 === mobileList.length"
              @click="addMobile" name="add-o" size="20px"/>
            <van-icon v-else
              @click="removeMobile(index)" name="close" class="fc-danger" size="20px"/>
          </div>
        </div>
      </div>
      <!-- <van-field
        label-width="70px"
        v-model="storeinfo.mainProducts"
        clearable
        required
        label="主营"
        placeholder="请输入主营信息"
      /> -->
      <van-field
        label-width="70px"
        v-model="storeinfo.guarantee"
        clearable
        label="担保"
        placeholder="担保信息"
      />
      <van-field
        label-width="70px"
        v-model="storeinfo.describe"
        clearable
        label="备注"
        placeholder="备注信息"
      />
      <!-- <div class="row bc-white contact pt1 pb1 align-items-center">
        <div class="required-box text-left"> <span class="required"></span> 报价种类</div>
        <div class="col">
          <van-checkbox v-model="crayfishLimit">龙虾报价</van-checkbox>
        </div>
        <div class="col">
          <van-checkbox v-model="crabLimit">螃蟹报价</van-checkbox>
        </div>
      </div> -->
      <div class="row bc-white contact pt1 pb1 align-items-center">
        <div class="required-box text-left"> <span class="required"></span> 开通权限</div>
        <div class="flex-1 row align-items-center">
          <van-checkbox-group v-model="userinfo.menuIds" direction="horizontal">
            <van-checkbox v-for="mn in menus" :name="mn.id" :key="mn.id" class="pt1 pb1">
              {{mn.name}}
            </van-checkbox>
          </van-checkbox-group>
        </div>
      </div>
      <div class="row bc-white contact pt1 pb1 align-items-center" style="cursor: pointer">
        <div class="required-box text-left">关联门店</div>
        <div class="flex-1 row align-items-center" @click="goStoreList()">
          {{webStore.miniStoreId ? `${webStore.miniStoreName||'已关联门店'}（点击更换）` : '点这里去关联门店'}}
        </div>
      </div>
      <div class="row bc-white contact pt1 pb1 align-items-center" style="cursor: pointer">
        <div class="required-box text-left">圈子用户</div>
        <div class="flex-1 row align-items-center" @click="goMemberList()">
          {{webMember.miniMemberId ? `${webMember.miniMemberName||'已绑定用户'}（点击更换）` : '点这里去绑定圈子用户'}}
        </div>
      </div>
      <div class="row bc-white contact pt1 pb1 align-items-center">
        <div class="required-box text-left"> 微信名片</div>
        <div class="col pr10">
          <van-uploader
            @click.native="clickUpload(-1)"
            class="col"
            width="100%"
            height="105"
            v-model="fileList"
            multiple
            :max-count="1"
            :after-read="afterRead"
            :preview-full-image="false"
            image-fit="cover"
            @delete="deleteImage(-1)"
          />
        </div>
      </div>
      <div class="row bc-white contact pt1 pb1 align-items-center">
        <div class="required-box text-left">价格来源</div>
        <div class="col row align-items-center">
          <div class="col-12 pr1 pl1" v-for="(psl, pslindex) in priceSourceList" :key="pslindex">
            <van-uploader
              @click.native="clickUpload(pslindex)"
              class="col"
              width="100%"
              height="105"
              v-model="psl.list"
              multiple
              :max-count="1"
              :after-read="afterRead"
              :preview-full-image="false"
              image-fit="cover"
              @delete="deleteImage(pslindex)"
              :disabled="loading"
            />
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="userType==='hzdw'">
      <van-field
        label-width="70px"
        v-model="userinfo.cooperationInfo.companyName"
        clearable
        label="公司名称"
        placeholder="请输入公司名称"
      />
      <div class="row bc-white contact pt1 pb1 align-items-center">
        <div class="required-box text-left">龙虾链接</div>
        <van-checkbox v-model="userinfo.cooperationInfo.geneCrayfishLink" @change="createLink(1)"></van-checkbox>
        <van-field
          label-width="70px" v-model="userinfo.cooperationInfo.link1" class="ml1 flex-1"/>
        <!-- <a class="padding2" v-if="userinfo.cooperationInfo.link1"
          @click="copyContentH5(userinfo.cooperationInfo.link1, userinfo.cooperationInfo.companyName+'\n龙虾链接：')">复制</a> -->
      </div>
      <div class="row bc-white contact pt1 pb1 align-items-center">
        <div class="required-box text-left">螃蟹链接</div>
        <van-checkbox v-model="userinfo.cooperationInfo.geneCrabLink" @change="createLink(2)"></van-checkbox>
        <van-field
          label-width="70px" v-model="userinfo.cooperationInfo.link2" class="ml1 flex-1"/>
        <!-- <a class="padding2" v-if="userinfo.cooperationInfo.link2"
          @click="copyContentH5(userinfo.cooperationInfo.link2, userinfo.cooperationInfo.companyName+'\n螃蟹链接：')">复制</a> -->
      </div>
      <div class="row bc-white contact pt1 pb1 align-items-center">
        <div class="required-box text-left"> <span class="required"></span> 开通权限</div>
        <div class="flex-1 row align-items-center">
          <van-checkbox-group v-model="userinfo.menuIds" direction="horizontal">
            <van-checkbox v-for="mn in menus" :name="mn.id" :key="mn.id" class="pt1 pb1">
              {{mn.name}}
            </van-checkbox>
          </van-checkbox-group>
        </div>
      </div>
    </template>
    <div class="row justify-content-around pr10 pl10 pt5 pb5">
      <van-button @click="back" class="btn-common" plain type="info">返回</van-button>
      <van-button @click="saveStore" class="btn-common" type="info">保存</van-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Base64 } from 'js-base64';
import {
  sendRequest, user, storeGet, storeAdd, storeUpdate, userReset, userDel, uploadFile, userAllDel,
  // saveLimit,
  upload, getregion, userDetail, getMenu,
} from '../../network/NetworkAccessor';
import storage from '../../uitls/cacheUtil';
import config from '../../config';

export default Vue.extend({
  name: 'UserEdit',
  components: {},
  props: {
    userType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      fileDomain: config.FILE_DOMAIN,
      loading: false,
      finished: true,
      uid: null,
      username: '',
      userinfo: { cooperationInfo: {} },
      storeinfo: {},
      changeFlag: false,
      crayfishLimit: 0,
      crabLimit: 0,
      webStore: {
        userId: '',
        webStoreId: '',
        webStoreName: '',
        miniStoreId: '',
        miniStoreName: '',
      },
      webMember: {
        miniMemberId: '',
        miniMemberName: '',
      },
      mobileList: [
        {
          mobile: '',
          name: '',
        },
      ],
      fileList: [],
      options: {},
      uploadIndex: -1,
      priceSourceList: [],
      test: 0,
      loginLink: '',
      menus: [],
      autoCopy: false,
      regionText: {},
    };
  },
  computed: {
    // 判断是否为新增模式
    isNewMode() {
      return !this.userinfo.id;
    },
    // sessionStorage key
    storageKey() {
      return `userEdit_temp_${this.userType}`;
    },
  },
  watch: {
    // 监听用户信息变化
    userinfo: {
      handler(val) {
        if (this.isNewMode) {
          this.saveToSessionStorage();
        }
      },
      deep: true,
    },
    // 监听店铺信息变化
    storeinfo: {
      handler(val) {
        if (this.isNewMode && this.userType === 'bjs') {
          this.saveToSessionStorage();
        }
      },
      deep: true,
    },
    // 监听联系方式变化
    mobileList: {
      handler(val) {
        if (this.isNewMode && this.userType === 'bjs') {
          this.saveToSessionStorage();
        }
      },
      deep: true,
    },
    // 监听文件列表变化
    fileList: {
      handler(val) {
        if (this.isNewMode && this.userType === 'bjs') {
          this.saveToSessionStorage();
        }
      },
      deep: true,
    },
    // 监听价格来源变化
    priceSourceList: {
      handler(val) {
        if (this.isNewMode && this.userType === 'bjs') {
          this.saveToSessionStorage();
        }
      },
      deep: true,
    },
    // 监听关联门店变化
    webStore: {
      handler(val) {
        if (this.isNewMode && this.userType === 'bjs') {
          this.saveToSessionStorage();
        }
      },
      deep: true,
    },
    // 监听圈子用户变化
    webMember: {
      handler(val) {
        if (this.isNewMode && this.userType === 'bjs') {
          this.saveToSessionStorage();
        }
      },
      deep: true,
    },
  },
  methods: {
    // 保存数据到sessionStorage
    saveToSessionStorage() {
      try {
        const data = {
          userinfo: this.userinfo,
          storeinfo: this.storeinfo,
          mobileList: this.mobileList,
          fileList: this.fileList,
          priceSourceList: this.priceSourceList,
          webStore: this.webStore,
          webMember: this.webMember,
          options: this.options,
        };
        sessionStorage.setItem(this.storageKey, JSON.stringify(data));
      } catch (e) {
        console.error('保存到sessionStorage失败:', e);
      }
    },
    // 从sessionStorage恢复数据
    restoreFromSessionStorage() {
      try {
        const data = sessionStorage.getItem(this.storageKey);
        if (data) {
          const parsed = JSON.parse(data);
          // 恢复用户信息（保留id和type）
          if (parsed.userinfo) {
            this.userinfo = {
              ...this.userinfo,
              ...parsed.userinfo,
              id: this.userinfo.id, // 保持id不变
              type: this.userinfo.type, // 保持type不变
            };
          }
          // 恢复店铺信息
          if (parsed.storeinfo && this.userType === 'bjs') {
            this.storeinfo = parsed.storeinfo || {};
          }
          // 恢复联系方式
          if (parsed.mobileList && this.userType === 'bjs') {
            this.mobileList = parsed.mobileList || [{ mobile: '', name: '' }];
          }
          // 恢复文件列表
          if (parsed.fileList && this.userType === 'bjs') {
            this.fileList = parsed.fileList || [];
          }
          // 恢复价格来源
          if (parsed.priceSourceList && this.userType === 'bjs') {
            this.priceSourceList = parsed.priceSourceList || [];
          }
          // 恢复关联门店
          if (parsed.webStore && this.userType === 'bjs') {
            this.webStore = parsed.webStore || this.webStore;
          }
          // 恢复圈子用户
          if (parsed.webMember && this.userType === 'bjs') {
            this.webMember = parsed.webMember || this.webMember;
          }
          // 恢复地区选项
          if (parsed.options && this.userType === 'bjs') {
            this.options = parsed.options || {};
          }
        }
      } catch (e) {
        console.error('从sessionStorage恢复数据失败:', e);
      }
    },
    // 清除sessionStorage数据
    clearSessionStorage() {
      try {
        sessionStorage.removeItem(this.storageKey);
      } catch (e) {
        console.error('清除sessionStorage失败:', e);
      }
    },
    goStoreList() {
      const query = {
        userId: this.userinfo.id || '',
        webStoreId: this.storeinfo.id || '',
        webStoreName: this.storeinfo.name || '',
        miniStoreId: this.storeinfo.miniStoreId || '',
        miniStoreName: this.storeinfo.miniStoreName || '',
        miniMemberId: this.webMember.miniMemberId || '',
        miniMemberName: this.webMember.miniMemberName || '',
      };
      const queryString = new URLSearchParams(query).toString();
      this.$router.replace(`/user/store/list/${this.storeinfo.id}?${queryString}`);
    },
    goMemberList() {
      const query = {
        fromUserEdit: 'true',
        userId: this.userinfo.id || '',
        webStoreId: this.storeinfo.id || '',
        webStoreName: this.storeinfo.name || '',
        miniMemberId: this.webMember.miniMemberId || '',
        miniMemberName: this.webMember.miniMemberName || '',
        miniStoreId: this.webStore.miniStoreId || '',
        miniStoreName: this.webStore.miniStoreName || '',
      };
      const queryString = new URLSearchParams(query).toString();
      this.$router.replace(`/member/list?${queryString}`);
    },
    // h5复制文本到剪切板
    copyContentH5(content = '', title = '') {
      // if (!content) {
      //   return;
      // }
      // const copyDom = document.createElement('div');
      // copyDom.innerText = `${title}${content}`;
      // copyDom.style.position = 'absolute';
      // copyDom.style.top = '0px';
      // copyDom.style.right = '-9999px';
      // document.body.appendChild(copyDom);
      // // 创建选中范围
      // const range = document.createRange();
      // range.selectNode(copyDom);
      // // 移除剪切板中内容
      // window.getSelection().removeAllRanges();
      // // 添加新的内容到剪切板
      // window.getSelection().addRange(range);
      // // 复制
      // const successful = document.execCommand('copy');
      // copyDom.parentNode.removeChild(copyDom);
      // try {
      //   this.$dialog.alert({
      //     message: successful ? '已复制到粘贴板' : '操作失败，请手动复制',
      //   });
      // } catch (err) {
      //   console.log('Oops , unable to copy!');
      //   this.$dialog.alert({
      //     message: '无法复制，请手动复制',
      //   });
      // }
    },
    createLink(type) {
      // TODO
      if (!this.userinfo.id || !this.userinfo.cooperationInfo[`gene${type === 1 ? 'Crayfish' : 'Crab'}Link`]) {
        this.$set(this.userinfo.cooperationInfo, `link${type}`, '');
        return;
      }
      const date = new Date();
      const month = date.getMonth() + 1;
      const monthStr = month > 9 ? month : `0${month}`;
      const d = date.getDate();
      const dStr = d > 9 ? d : `0${d}`;
      const queryDate = `${date.getFullYear()}${monthStr}${dStr}`;
      // for 合作单位定制链接
      // companyIdStr: 处理后的合作单位id、报价类型(处理规则：base64(`${companyId}_${quoteType}`))
      // '/baojia/:companyIdStr/list/:queryDate'
      const companyIdStr = Base64.encodeURL(`${this.userinfo.id}_${type}`);
      const link = `${config.DOWNLOAD_DOMAIN}/${companyIdStr}/baojia/${queryDate}`;
      // console.log(`${this.userinfo.id}_${type}`);
      // console.log(companyIdStr, Base64.decode(companyIdStr));
      // console.log(link);
      this.$set(this.userinfo.cooperationInfo, `link${type}`, link);
    },
    createLoginLink() {
      if (!this.userinfo.id) {
        return;
      }
      const companyIdStr = Base64.encodeURL(`_${this.userinfo.id || ''}`);
      this.loginLink = `${config.DOWNLOAD_DOMAIN}/${companyIdStr}/login`;
    },
    changeRegion(type) {
      if (!type) {
        return;
      }
      const pcode = this.storeinfo[`${type}Code`];
      let optionsKey = '';
      if (type === 'province') {
        optionsKey = 'city';
        this.$set(this.storeinfo, 'cityCode', '');
        this.$set(this.storeinfo, 'areaCode', '');
        this.$set(this.storeinfo, 'townCode', '');
      } else if (type === 'city') {
        optionsKey = 'area';
        this.$set(this.storeinfo, 'areaCode', '');
        this.$set(this.storeinfo, 'townCode', '');
      } else if (type === 'area') {
        optionsKey = 'town';
        this.$set(this.userinfo, 'townCode', '');
      } else if (type === 'town') {
        const sheng = this.options.provinceOptions.find(op => op.code === this.storeinfo.provinceCode) || {};
        const shi = this.options.cityOptions.find(op => op.code === this.storeinfo.cityCode) || {};
        const qu = this.options.areaOptions.find(op => op.code === this.storeinfo.areaCode) || {};
        const zhen = this.options.townOptions.find(op => op.code === this.storeinfo.townCode) || {};
        this.$set(this.storeinfo, 'address', `${sheng.name}${shi.name.includes('市辖区') || shi.name.includes('行政区划') ? '' : shi.name}${qu.name}${zhen.name}`);
      }
      if (optionsKey) {
        this.getRegion(optionsKey, pcode);
      }
    },
    getRegion(optionsKey = 'province', pcode) {
      sendRequest(getregion, { pcode }).then((res = []) => {
        const options = res || [];
        this.$set(this.options, `${optionsKey}Options`, options);
      }).catch((e) => {
        this.$dialog.alert({
          message: e.message,
        });
      });
    },
    formatFileList() {
      if (this.storeinfo.qrcode) {
        this.fileList = [{
          url: this.fileDomain + this.storeinfo.qrcode,
        }];
        return;
      }
      this.fileList = [];
    },
    deleteImage(index) {
      this.uploadIndex = index;
      console.log(index);
      if (this.uploadIndex > -1) {
        this.$set(this.priceSourceList[this.uploadIndex], 'list', []);
      } else {
        this.$set(this.storeinfo, 'qrcode', '');
        this.$set(this.storeinfo, 'qrcodeFile', '');
      }
    },
    clickUpload(index) {
      console.log(index);
      this.uploadIndex = index;
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      if (this.uploadIndex > -1) {
        this.deleteImage(this.uploadIndex);
        this.test += 1;
        if (this.test > 4) {
          this.afterRead = () => {};
        }
        this.uploadSource(file.file);
      } else {
        this.uploadQrcode(file.file);
        // this.$set(this.storeinfo, 'qrcode', '');
        // this.$set(this.storeinfo, 'qrcodeFile', file.file);
      }
    },
    uploadQrcode(file) {
      this.loading = true;
      const params = new FormData();
      params.append('file', file);
      upload(uploadFile, params).then((url = '') => {
        this.$set(this.storeinfo, 'qrcode', url);
        this.fileList = [{ url: this.fileDomain + url, tempurl: url }];
      }).catch((e) => {
        console.log(e);
        // this.$set(this.storeinfo, 'qrcode', '');
      }).then(() => {
        this.loading = false;
      });
    },
    uploadSource(file) {
      this.loading = true;
      const params = new FormData();
      params.append('file', file);
      upload(uploadFile, params).then((url = '') => {
        this.$set(this.priceSourceList[this.uploadIndex], 'list', [
          { url: this.fileDomain + url, tempurl: url },
        ]);
      }).catch((e) => {
        console.log(e);
      }).then(() => {
        this.loading = false;
      });
    },
    saveImage() {
      const params = new FormData();
      Object.entries(this.storeinfo).forEach(([key, value]) => {
        if (value) {
          params.append(key, value);
        }
      });
      if (!this.storeinfo.qrcode) {
        params.append('qrcode', '');
      }
      const list = (this.priceSourceList || []).map(vl => ((vl.list || [])[0] || {}).tempurl);
      params.append('priceSourceUrl', list.filter(v => v).join(','));
      const methodName = this.storeinfo.id ? storeUpdate : storeAdd;
      return upload(methodName, params);
    },
    setSource(storeinfo = {}) {
      let priceSourceList = (storeinfo.priceSourceUrl || '').split(',').filter(spl => spl).map(it => ({
        list: [{
          url: this.fileDomain + it,
          tempurl: it,
        }],
      }));
      if (priceSourceList.length < 4) {
        priceSourceList = priceSourceList.concat(Array.from({ length: 4 - priceSourceList.length }, () => ({
          list: [],
        })));
      }
      this.priceSourceList = priceSourceList;
    },
    getMenu() {
      if (!this.userinfo.id) {
        sendRequest(getMenu, { type: this.userinfo.type }).then((res) => {
          this.menus = res || [];
        }).catch((e) => {
        });
      }
    },
    getUserDetail() {
      if (!this.userinfo.id) {
        return;
      }
      sendRequest(userDetail, { userId: this.userinfo.id }).then((res = {}) => {
        this.userinfo = Object.assign({}, this.userinfo, res);
        this.menus = res.menus || [];
        this.userinfo.menuIds = this.menus.filter(m => m.checked).map(m => m.id);
      }).catch((e) => {
        this.$dialog.alert({
          message: e.message || '查询失败',
        });
      }).then(() => {
        if (this.userinfo.cooperationInfo.geneCrayfishLink) {
          this.createLink(1);
        }
        if (this.userinfo.cooperationInfo.geneCrabLink) {
          this.createLink(2);
        }
      });
    },
    getStore() {
      if (this.userinfo.type !== 2) {
        return;
      }
      if (!this.userinfo.id) {
        this.setSource();
        return;
      }
      sendRequest(storeGet, { userId: this.userinfo.id }).then((res) => {
        console.log(res);
        const storeinfo = res || {};
        let mobileList = [];
        try {
          mobileList = JSON.parse(storeinfo.mobile);
          if (Object.prototype.toString.call(mobileList) !== '[object Array]') {
            mobileList = [];
          }
        } catch (error) {
          mobileList = [];
        }
        if (!mobileList || !mobileList.length) {
          mobileList = [{
            mobile: '',
            name: '',
          }];
        }
        this.mobileList = mobileList;
        const {
          provinceCode = '', cityCode = '', areaCode = '', townCode = '',
        } = storeinfo;
        storeinfo.provinceCode = provinceCode;
        storeinfo.cityCode = cityCode;
        storeinfo.areaCode = areaCode;
        storeinfo.townCode = townCode;
        console.log(provinceCode);
        if (provinceCode) {
          this.getRegion('city', provinceCode);
        }
        if (cityCode) {
          this.getRegion('area', cityCode);
        }
        if (areaCode) {
          this.getRegion('town', areaCode);
        }
        this.setSource(storeinfo);
        delete storeinfo.priceSourceUrl;
        this.storeinfo = storeinfo;
        if (!this.webStore.miniStoreId) {
          this.webStore = {
            ...this.webStore,
            miniStoreId: storeinfo.miniStoreId || '',
            miniStoreName: storeinfo.miniStoreName || '',
          };
        }
        if (!this.webMember.miniMemberId) {
          this.webMember = {
            ...this.webMember,
            miniMemberId: storeinfo.miniMemberId || '',
            miniMemberName: storeinfo.miniMemberName || '',
          };
        }
      }).catch((e) => {
      }).then(() => {
        this.formatFileList();
      });
      // sendRequest(getLimit, { userId: this.userinfo.id }).then((res) => {
      //   console.log(res);
      //   const { crayfishLimit = 0, crabLimit = 0 } = res;
      //   this.crayfishLimit = crayfishLimit;
      //   this.crabLimit = crabLimit;
      // }).catch((e) => {
      // });
    },
    changePWD() {
      if (this.changeFlag) {
        if (!this.userinfo.newPassword) {
          this.$dialog.alert({
            message: '请输入新密码',
          });
          return;
        }
        this.$dialog.confirm({
          title: '确认',
          message: `确认修改${this.userinfo.username}的密码为${this.userinfo.newPassword}吗？`,
        }).then(() => {
          sendRequest(userReset, {
            userId: this.userinfo.id,
            newPassword: this.userinfo.newPassword,
          }).then((res) => {
            this.$dialog.alert({
              message: '密码已修改',
            });
          }).catch((e) => {
            this.$dialog.alert({
              message: '修改密码失败',
            });
          }).then(() => {
            this.changeFlag = false;
          });
        }).catch(() => {
          // on cancel
          this.changeFlag = false;
        });
      } else {
        this.changeFlag = true;
      }
    },
    removeUser() {
      this.$dialog.confirm({
        title: '确认',
        message: `确认删除账户${this.userinfo.username}吗？`,
      }).then(() => {
        sendRequest(userDel, {
          userId: this.userinfo.id,
        }).then((res) => {
          this.$router.push('/user/list');
        // this.$dialog.alert({
        //   message: '用户已删除'
        // });
        }).catch((e) => {
          this.$dialog.alert({
            message: e.message || '删除失败',
          });
        });
      }).catch(() => {
        // on cancel
      });
    },
    removeAll() {
      this.$dialog.confirm({
        title: '确认',
        message: `确认删除账户${this.userinfo.username}全部信息吗？`,
      }).then(() => {
        sendRequest(userAllDel, {
          userId: this.userinfo.id,
        }).then((res) => {
          this.$router.push('/user/list');
        // this.$dialog.alert({
        //   message: '用户已删除'
        // });
        }).catch((e) => {
          this.$dialog.alert({
            message: e.message || '删除失败',
          });
        });
      }).catch(() => {
        // on cancel
      });
    },
    saveUser() {
      this.userinfo.userId = this.userinfo.id;
      return sendRequest(user, this.userinfo).then((res) => {
        if (!this.userinfo.id) {
          this.$set(this.userinfo, 'id', res || '');
        }
        console.log(res);
      });
    },
    saveStore() {
      if (!this.userinfo.id && (!this.userinfo.username || !this.userinfo.password)) {
        this.$dialog.alert({
          message: '用户名和密码必填',
        });
        return '';
      }
      const mobileList = (this.mobileList || []).filter(m => m.mobile);
      if (this.userinfo.type === 2) {
        if (
        // !this.storeinfo.guarantee
        // || !this.storeinfo.mainProducts
        // || !mobileList
        // || mobileList.length < 1
        // || !this.storeinfo.name
        // || !this.storeinfo.describe
          !this.storeinfo.provinceCode
            || !this.storeinfo.cityCode
            || !this.storeinfo.areaCode
            || !this.storeinfo.townCode
        ) {
          this.$dialog.alert({
            message: '请完善店铺信息',
          });
          return false;
        }
        const quoteTypes = this.menus.filter(m => m.route === 'QuotationEdit').map(m => m.id);
        const flag = this.userinfo.menuIds.some(m => quoteTypes.includes(m));
        if (!flag) {
          this.$dialog.alert({
            message: '请至少选择一种产品报价',
          });
          return false;
        }
      } else if (this.userinfo.type === 3) {
        if (this.userinfo.menuIds.length < 1) {
          this.$dialog.alert({
            message: '请至少选择一个权限',
          });
          return false;
        }
        this.saveUser().then(() => {
          // 保存成功后清除sessionStorage
          this.clearSessionStorage();
          // if (this.autoCopy) {
          //   this.createLoginLink();
          //   let link1 = '';
          //   let link2 = '';
          //   if (this.userinfo.cooperationInfo.geneCrayfishLink) {
          //     this.createLink(1);
          //     link1 = `\n龙虾链接：${this.userinfo.cooperationInfo.link1}`;
          //   }
          //   if (this.userinfo.cooperationInfo.geneCrabLink) {
          //     this.createLink(2);
          //     link2 = `\n龙虾链接：${this.userinfo.cooperationInfo.link2}`;
          //   }
          //   this.copyContentH5(`${this.userinfo.cooperationInfo.companyName}\n登录链接：${this.loginLink}${link1}${link2}`);
          //   setTimeout(() => {
          //     this.$router.back();
          //   }, 2000);
          //   return;
          // }
          // this.$router.push(this.$route.params.id ? '/user/list' : '/home');
          this.$router.back();
        }).catch((e) => {
          this.$dialog.alert({
            message: `${e.message || '保存合作单位失败'}`,
          });
        });
        return false;
      }
      Promise.resolve().then(() => this.saveUser()).then(() => {
        if (!this.userinfo.id) {
          return;
        }
        // sendRequest(saveLimit, {
        //   userId: this.userinfo.id,
        //   crayfishLimit: this.crayfishLimit ? 1 : 0,
        //   crabLimit: this.crabLimit ? 1 : 0,
        // }).then((res) => {
        //   console.log(res);
        // }).catch((e) => {
        //   this.$dialog.alert({
        //     message: `${e.message || '保存报价种类失败'}`,
        //   });
        // });
        this.storeinfo.userId = this.userinfo.id;
        this.storeinfo.mobile = JSON.stringify(mobileList);
        this.storeinfo.miniStoreId = this.webStore.miniStoreId;
        this.storeinfo.miniStoreName = this.webStore.miniStoreName;
        this.storeinfo.miniMemberId = this.webMember.miniMemberId;
        this.storeinfo.miniMemberName = this.webMember.miniMemberName;
        this.saveImage().then((res) => {
          // 保存成功后清除sessionStorage
          this.clearSessionStorage();
          // console.log(res);
          // this.$dialog.alert({
          //   message: '保存成功'
          // });
          // this.$router.push('/user/list');
          // this.$router.push(this.$route.params.id ? '/user/list' : '/home');
          this.back();
        }).catch((e) => {
          this.$dialog.alert({
            message: e.message || '保存店铺信息失败',
          });
        });
      }).catch((err) => {
        console.error(err);
        this.$dialog.alert({
          message: err.message || '保存用户信息失败',
        });
      });
      return true;
    },
    addMobile() {
      this.mobileList.push({
        mobile: '',
        name: '',
      });
    },
    removeMobile(index) {
      if (this.mobileList.length === 1) {
        this.mobileList = [{
          mobile: '',
          name: '',
        }];
        return;
      }
      this.mobileList.splice(index, 1);
    },
    back() {
      this.$router.replace('/user/list');
    },
  },
  created() {
    const {
      userId = '',
      webStoreId = '',
      webStoreName = '',
      miniStoreId = '',
      miniStoreName = '',
      miniMemberId = '',
      miniMemberName = '',
    } = this.$route.query;
    console.log('query', this.$route.query);
    this.webStore = {
      userId,
      webStoreId,
      webStoreName,
      miniStoreId,
      miniStoreName,
    };
    this.webMember = {
      miniMemberId,
      miniMemberName,
    };

    const username = storage.local.get('busername');
    this.userinfo = {
      id: this.$route.params.id,
      username,
      cooperationInfo: {},
      menuIds: [],
      type: this.userType === 'hzdw' ? 3 : 2, // 用户类型 2：报价商 3：合作单位
    };

    // 新增模式下，从sessionStorage恢复数据
    if (!this.$route.params.id) {
      this.restoreFromSessionStorage();
    }

    this.getMenu();
    this.getUserDetail();
    if (this.userType === 'bjs') {
      this.getStore();
      this.getRegion();
      return;
    }
    if (this.userinfo.id) {
      this.autoCopy = false;
    } else {
      this.autoCopy = true;
    }
    this.createLoginLink();
  },

});
</script>
<style scoped>
  .UserEdit {
    min-height: 100vh;
  }
  .UserEdit >>> .van-uploader__upload,.UserEdit >>> .van-uploader__preview{
    width: 100%;
  }
  .UserEdit >>> .van-uploader__preview-image{
    width: 100%;
  }
  .UserEdit >>> .van-uploader__file {
    width: 100%;
  }
  .UserEdit >>> .van-uploader__preview-image {
    height: auto;
  }
  .title {
    padding: 20px 0;
    font-size: 20px;
  }
  .UserEdit {
    padding: 10px 5px;
  }
  .van-cell {
    text-align: left;
  }
  .btn {
    width: 80%;
  }
  .btn-reset {
    width: 25%;
    margin: 0 10px;
  }
  .required-box {
    width: 72px;
  }
  .required::before {
    position: absolute;
    left: 8px;
    color: #ee0a24;
    font-size: 14px;
    content: '*';
  }
  .contact {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding-left: 16px;
    overflow: hidden;
    color: #323233;
    font-size: 14px;
    line-height: 24px;
    background-color: #fff;
  }
  .contact:after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 0;
    bottom: 0;
    left: 16px;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
}
.ad-select {
  width: 100%;
}
.UserEdit >>> .van-uploader__wrapper {
  min-height: 80px;
}
</style>
